<div class="popup">
    <h1 class="popup-title" [i18n]="'eta-details.list-title'"></h1>

    <app-data-table [columns]="columns"
                    [additionalRowTemplate]="etaDetails"
                    [showColumnsSelection]="false"
                    [loadPage]="loadEtas"
                    [hidePageSelector]="true"
                    [loadAtStartup]="true"
                    [disableSearch]="true"
                    [selectOnRowClick]="false"
                    [noOverflow]="true">
    </app-data-table>

    <div class="form-group text-center">
        <button class="btn btn-i btn-primary btn-md" (click)="close.emit()" type="submit">
            <span [i18n]="'eta-details.close-popup'"></span>
        </button>
    </div>
</div>


<ng-template #sourceColumn let-item="item">
    <div [class._sent]="latestEtaReportId === item.id">
        {{ 'eta-details.initiator.' + getInitiator(item.emitter, item.eventSource) | translate }}
    </div>
</ng-template>

<ng-template #etaColumn let-item="item">
    <div class="etaSchedule" [class._sent]="latestEtaReportId === item.id">
        {{ item.eta | date:'yyyy-MM-dd HH:mm' }}
        <small class="etaSchedule-utc">{{ item.destinationTimezoneOffset }}</small>
    </div>
</ng-template>

<ng-template #geopositionColumn let-item="item">
    <div [class._sent]="latestEtaReportId === item.id">
        {{ item.latitude }} / {{ item.longitude }}
    </div>
</ng-template>

<ng-template #sentToMyChepColumn let-item="item">
    <div [class._sent]="latestEtaReportId === item.id">
        {{ (item.sentToMyChep ? 'eta-details.sent-to-my-chep-yes' : 'eta-details.sent-to-my-chep-no') | translate }}
    </div>
</ng-template>

<ng-template #expandDetailsColumn let-item="item">
        <span class="collapseAction _light" (click)="toggleDisplayEvents(item.id)">
            <i class="fas fa fa-angle-down" *ngIf="!isSelectedLoad(item.id)"></i>
            <i class="fas fa-angle-up" *ngIf="isSelectedLoad(item.id)"></i>
        </span>
</ng-template>

<ng-template #etaDetails let-item="item">
    <div class="etaDetails">
        <div class="etaDetails-item">
            <label>{{ 'eta-details.calculation-date'|translate }} :</label>
            {{ item.calculationDate | date:'yyyy-MM-dd HH:mm' }}
            <!-- CalculationDate is always UTC+0 , as it is in the server default timezone-->
            <small class="etaSchedule-utc">UTC+00:00</small>
        </div>
        <div class="etaDetails-item">
            <label>{{ 'eta-details.inputs-used'|translate }} :</label>
            <ng-container *ngFor="let input of calculateInputsForEtaDetail(item); let last = last">
                {{ 'eta-details.input.' + input | translate }}{{ last ? '' : ', ' }}
            </ng-container>
        </div>
        <div class="etaDetails-item">
            <label>{{ 'eta-details.service-used'|translate }} :</label>
            {{ item.emitter === EtaEmitter.CMBL_AUTOMATIC_ETA ? 'PC Miler' : '/' }}
        </div>
    </div>
</ng-template>
